

















import { Vue, Prop, Watch, Component } from 'vue-property-decorator'

const fields = [
  { label: '服务顾问', key: 'service_consultant' },
  { label: '销售顾问', key: 'sales_consultant' },
  { label: '招揽专员', key: 'soliciter' },
  { label: '续保专员', key: 'renewal_employee' },
  { label: '客户经理', key: 'account_manager' }
]

type IField = {
  label: string
  value: string
}

@Component({})
export default class ServicePersonnel extends Vue {
  @Prop(Number) readonly baseCarId!: number;

  renderFields: IField[] = [];

  mounted () {
    this.getServiceEmployee(this.baseCarId)
  }

  loading = false
  async getServiceEmployee(baseCarId: number) {
    if (!baseCarId) return
    if (this.loading) return
    this.loading = true
    try {
      const { code, data } = await this.$rest.aftersales.getServiceEmployee(baseCarId)()
      if (code) return
      this.renderFields = fields.reduce((arr, cur) => {
        if (data[cur.key] && data[cur.key].id) {
          arr.push({ label: cur.label, value: data[cur.key].name })
        }
        return arr
      }, [] as IField[])
    } finally {
      this.loading = false
    }
  }
}
